  import React, { useContext, useEffect, useMemo, useState } from 'react'
  import { AuthContext } from 'contexts'
  import { Button, MegaMenu, Menu, MenuGroup } from 'components'
  import { menus, extraMenu} from './menuList'
  import ls from 'utils/ls'
  import { Link, useNavigate } from 'react-router-dom'
  import { twMerge } from 'tailwind-merge'
  import { RightIcon } from 'assets/icons'
  import axios from 'axios'
  import logo from 'assets/images/warehouseLogo.png'
  import ExtraMenu from './ExtraMenu'


  const mmKey = ls.get('mmKey')
  const mKey = ls.get('mKey')

  function Sidebar() {
    const [ collapsed, setCollapsed ] = useState(true)
    const [ copmany, setCompany ] = useState(true)
    const { state, action } = useContext(AuthContext)
    const [ currentMegaKey, setCurrentMegaKey ] = useState(mmKey ? mmKey : 'hr')
    const [ currentMenu, setCurrentMenu ] = useState(null)
    const [ currentMenuKey, setCurrentMenuKey ] = useState(mKey ? mKey : [])
    const [ loading, setLoading ] = useState(false)
    const [ menuForms, setMenuForm ] = useState([])

    const navigate = useNavigate()

    const megaMenu = useMemo(() => {
      return menus
    },[])
    const menu = useMemo(() => {
      let tmp = []
      if(currentMenu){
        const defaultItem = currentMenu.menu.find((item) => item.default)
        if(currentMenuKey !== defaultItem.key){
          ls.set('mKey', [defaultItem.key])
          setCurrentMenuKey([defaultItem.key])
          navigate(defaultItem.to)
        }
        tmp = currentMenu
      }else{
        tmp = menus.find((item) => item.key === currentMegaKey)
      }
      return tmp
    },[currentMegaKey, currentMegaKey ])
    
    useEffect(() => {
      let tmp = [];
      menus.map((item) => {
        console.log(state.userInfo?.forms?.find((el) => el === item.formCode || item.formCode === "ALL"))
        if(state.userInfo?.forms?.find((el) => el === item.formCode || item.formCode === "ALL")){
          tmp.push(item);
        }
      });
      setMenuForm(tmp)
      // getCompany()
    },[
      // state?.userInfo?.user?.id
    ]);
    // const getCompany = () => {
    //   setLoading(true)
    //   axios({
    //     method: 'get',
    //     url:'company'
    //   }).then((res) => {
    //       setCompany(res.data)
    //   }).catch((err) => {
    //   }).finally(() => setLoading(false))
    // }
    console.log(menus);
    const handleSelectMegaMenu = (key, item) => {
      if(currentMegaKey !== key){
        ls.set('mmKey', key)
        setCurrentMegaKey(key)
        setCurrentMenu(item)
      }
    }
    
    const handleSelectMenu = (key) => {
      if(JSON.stringify(currentMenuKey) !==  JSON.stringify(key)){
        ls.set('mKey', key)
        setCurrentMenuKey(key)
      }
    }
    const toggleSidebar = () => {
      setCollapsed(!collapsed);
    };
    return (
      <div 
        className={`sidebar ${collapsed ? 'collapsed-sidebar' : ''}`}
      >
        <div className='flex relative mx-16'>
        <img src={logo} alt='logo' className='absolute inset-0 object-cover'  />
          </div>
        <div className='flex flex-col gap-3'>
          <div
              className={`w-full flex items-center whitespace-nowrap rounded text-primary`}
            >
              { currentMegaKey.icon ? 
                <>
                  <span className='flex p-2 {pl-40px}'>{currentMegaKey.icon}</span> 
                  <span className='ml-3 text-lg font-semibold'>{currentMegaKey.label}</span>
                </>
                :
                <span className='{ml-[68px]}'>{currentMegaKey.label}</span>
              }
            </div>
            <div className='flex flex-col '>
            {menuForms && (
              <div key={menuForms.key}>
                <div className=''>
                  <div>
                    <Menu
                      items={menuForms} // Change [menuForms] to menuForms
                      currentKey={currentMenuKey}
                      onChange={handleSelectMenu}
                      isOpen={collapsed}
                    />
                    <ExtraMenu
                      items={extraMenu}
                      currentKey={currentMenuKey}
                      onChange={handleSelectMenu}
                      isOpen={collapsed}
                    />
                  </div>
                </div>
              </div>
            )}
                <div
                  key={`mega-menu-button`}
                  className={`w-full flex items-center justify-end whitespace-nowrap rounded cursor-pointer py-2 px-3 hover:bg-extramenu-300 hover:text-inite-50`}
                  onClick={() => setCollapsed(!collapsed)}
                >
                  <div className='px-2'>
                    <RightIcon size={20} className={twMerge('transition-all origin-center', collapsed ? 'rotate-180' : '')} />
                  </div>
                </div>
              
              </div>
        </div>
      </div>
    )
  }

  export default Sidebar